import { render, staticRenderFns } from "./DeliveryCustomerNotePrint.vue?vue&type=template&id=331f00b8&scoped=true&"
import script from "./DeliveryCustomerNotePrint.vue?vue&type=script&lang=js&"
export * from "./DeliveryCustomerNotePrint.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryCustomerNotePrint.vue?vue&type=style&index=0&id=331f00b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331f00b8",
  null
  
)

export default component.exports